import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../../../../../hooks';
import '../Loading/Loading.scss';
export const Fetching = ({ fetching, loading }) => {
    const containerClassName = useClassName({ name: 'auto-complete-loading', prefixed: true });
    const optionClassName = useClassName({ name: 'auto-complete-loading-option', prefixed: true });
    if (!fetching || loading)
        return null;
    return (_jsx("div", { "data-testid": 'auto-complete-loading', className: containerClassName, children: _jsx("div", { className: optionClassName }) }));
};
